import { post } from 'axios'
// import store from '@/store'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

// put
function setInterviewResults (pFormData, pIdEnglishInterviewSchedule) {
    const URI = `${BASE_URL}/api/englishInterviewSchedules/${pIdEnglishInterviewSchedule}/interviewResults`
    return post(URI, pFormData, { headers })
}

export { setInterviewResults }